export class ValidationConsts {
  public static VALIDATION_MESSAGES = {
    default: () => 'InvalidField',
    required: () => 'FieldRequired',
    /** "Minimum length of ${minlength} is required" */
    minLength: (requiredLength, actualLength) => 'MinLength',
    min: (min, actual) => 'MinValue',
    dateRange: (error) => 'InvalidDateRange',
  };
}
